import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, Map, X } from "lucide-react";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { FirstProjectWizard } from "./FirstProjectWizard";

export function FirstProjectGuide() {
  const [g, setG] = useState(null);
  const [wiz, setWiz] = useState(false);
  const nav = useNavigate();
  const load = () => api.get("/guide").then((r) => setG(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!g || g.completed) return null;
  const hide = (hidden) => api.put("/guide", { hidden }).then((r) => setG(r.data));
  if (g.hidden) return <button type="button" onClick={() => hide(false)} className="text-xs text-amber-300 hover:underline mb-6 inline-flex items-center gap-1" data-testid="guide-show"><Map size={12} />Show the first-project guide</button>;
  const go = (s) => (s.tab && g.project ? nav(`/app/books/${g.project.id}?tab=${s.tab}`) : setWiz(true));
  return (
    <div className="panel p-6 mb-10 relative" data-testid="first-project-guide">
      <button type="button" onClick={() => hide(true)} className="absolute top-4 right-4 text-slate-500 hover:text-slate-200" aria-label="Hide guide" data-testid="guide-hide"><X size={16} /></button>
      <p className="eyebrow mb-1 flex items-center gap-2"><Map size={13} />Your first project · {g.done}/{g.total}</p>
      <p className="font-display text-2xl mb-1">{g.project ? `Let's publish “${g.project.title}”` : "Let's make your first book"}</p>
      <p className="text-sm text-slate-400 mb-5">Follow these steps in order — each one ticks itself off as you finish it.</p>
      <div className="h-1.5 rounded-full bg-slate-800 overflow-hidden mb-5"><div className="h-full bg-amber-500 transition-[width] duration-700" style={{ width: `${(g.done / g.total) * 100}%` }} /></div>
      <ol className="grid sm:grid-cols-2 gap-2 mb-5">
        {g.steps.map((s, i) => (
          <li key={s.label}>
            <button type="button" onClick={() => go(s)} disabled={s.done && i === 0} data-testid={`guide-step-${i}`}
              className={`w-full flex items-center gap-3 text-left rounded-lg border px-3 py-2 transition-colors ${s.done ? "border-emerald-500/30 bg-emerald-900/10 text-emerald-200" : g.next?.label === s.label || (!g.project && i === 0) ? "border-amber-500/60 bg-amber-500/10 text-slate-100" : "border-slate-800 text-slate-400 hover:border-slate-600"}`}>
              <span className={`w-6 h-6 rounded-full flex items-center justify-center text-[11px] shrink-0 ${s.done ? "bg-emerald-600 text-white" : "border border-slate-600"}`}>{s.done ? <Check size={13} /> : i + 1}</span>
              <span className="text-sm">{s.label}</span>
            </button>
          </li>
        ))}
      </ol>
      {g.project ? (g.next && <Button onClick={() => go(g.next)} className="bg-amber-600 hover:bg-amber-500" data-testid="guide-next">Next: {g.next.label} →</Button>)
        : <Button onClick={() => setWiz(true)} className="bg-amber-600 hover:bg-amber-500" data-testid="guide-start">Start guided set-up</Button>}
      <FirstProjectWizard open={wiz} onClose={() => { setWiz(false); load(); }} />
    </div>
  );
}
